export const urlInclude = [
  '//www.bilibili.com',
  '//t.bilibili.com',
  '//search.bilibili.com',
  '//space.bilibili.com',
  '//account.bilibili.com',
  '//pay.bilibili.com',
  '//member.bilibili.com',
  '//big.bilibili.com',
  '//message.bilibili.com',
  '//app.bilibili.com',
  '//passport.bilibili.com',
  '//live.bilibili.com/blackboard/',
  '//music.bilibili.com',
]
export const urlExclude = [
  '//t.bilibili.com/vote/h5/index/#/result',
  '//t.bilibili.com/lottery/h5/index/#/result',
  '//member.bilibili.com/video/upload',
  '//member.bilibili.com/platform',
  '//space.bilibili.com/ajax/',
  '//www.bilibili.com/h5/comment/',
  // '//www.bilibili.com/blackboard/',
  '//member.bilibili.com/v2',
  '//game.bilibili.com/',
  '//www.bilibili.com/mooc/',
  '//www.bilibili.com/bubble/publish',
  '//www.bilibili.com/toy/',
  '//member.bilibili.com/editor/',
]
